/**
 * Fallback function
 * @method noop
 * @returns {undefined}
 */
export default () => {}
